import * as React from 'react';
import { InfoPopup } from '../../Popups';

import infoIcon from 'assets/info.svg';

import './style.scss';

export type InfoIconProps = {
    popupText: string;
    clickAwayRootId?: string;
};

export const InfoIcon: React.FC<InfoIconProps> = ({
    popupText,
    clickAwayRootId,
}: InfoIconProps) => {
    const [popupShowing, setPopupShowing] = React.useState(false);

    const togglePopup = React.useCallback(() => {
        setPopupShowing(!popupShowing);
    }, [popupShowing]);

    return (
        <div className="rw-info-container">
            <button className="rw-icon-info-button" onClick={(e) => togglePopup()}>
                <img src={infoIcon} />
            </button>
            <InfoPopup
                isShowing={popupShowing}
                hasCloseButton={false}
                onHide={() => setPopupShowing(false)}
                clickAwayRootId={clickAwayRootId}
                text={popupText}
                horizontalAlign="right"
                verticalAlign="bottom"
                //variant="loud"
            />
        </div>
    );
};
